/* src/app/components/controls/sem-cadastral-parcel-control/sem-cadastral-parcel-control.component.css */
.sem-cadastral-parcel-control {
  width: 100%;
  margin-top: 10px;
}
.cadastral-inputs-container {
  display: flex;
  align-items: stretch;
  gap: 15px;
  flex-wrap: nowrap;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  min-height: 48px;
}
.ko-input-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}
.ko-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 0;
  white-space: nowrap;
}
.ko-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  text-align: left;
  min-height: 40px;
}
.ko-input:focus {
  outline: none;
  border-color: #007bff;
}
.municipality-name-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  min-width: unset;
  max-width: unset;
}
.municipality-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 0;
  white-space: nowrap;
}
.municipality-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.municipality-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
  min-height: 40px;
  text-align: left;
}
.loader {
  position: absolute;
  right: 10px;
  left: auto;
  display: flex;
  align-items: center;
  width: 30px;
  height: 30px;
}
.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.municipality-input.has-value {
  color: #333;
  font-weight: 500;
  background-color: #e9ecef;
}
.municipality-input:focus {
  outline: none;
  border-color: #007bff;
}
@media (max-width: 768px) {
  .cadastral-inputs-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .ko-input-group {
    justify-content: space-between;
    width: 100%;
  }
  .ko-input {
    flex: 1;
    max-width: 150px;
    margin-left: auto;
  }
  .municipality-name-group {
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
}
.cadastral-inputs-container:has(.ko-input:disabled) {
  background-color: #f8f9fa;
  color: #6c757d;
}
.ko-input:disabled,
.municipality-input {
  background-color: #e9ecef;
  opacity: 1;
}
.cadastral-inputs-container:focus-within .municipality-input.has-value {
  border-color: #007bff;
}
/*# sourceMappingURL=sem-cadastral-parcel-control.component.css.map */
